export default {
  base: {
    border: '1px solid',
    p: 'sm',
    variant: 'spark.base.wrapper',
    title: {
      variant: undefined,
      display: 'inline-block',
      fontWeight: 600,
      fontSize: '20px',
      lineHeight: '24px',
      fontFamily: 'heading'
    },
    header: {
      display: 'flex',
      alignItems: 'flex-start',
      pb: 'sm'
    },
    close: {
      display: 'inline-block',
      flexShrink: '0',
      height: '24px',
      ml: '4px',
      position: 'relative'
    }
  },
  variants: {
    info: {
      variant: 'spark.element.alert.base',
      backgroundColor: 'grey-05',
      borderColor: 'grey-20',
      title: {
        variant: 'spark.element.alert.base.title'
      },
      header: {
        variant: 'spark.element.alert.base.header'
      },
      close: {
        variant: 'spark.element.alert.base.close'
      }
    },
    error: {
      variant: 'spark.element.alert.base',
      backgroundColor: 'red-25',
      borderColor: 'error',
      title: {
        variant: 'spark.element.alert.base.title'
      },
      header: {
        variant: 'spark.element.alert.base.header'
      },
      close: {
        variant: 'spark.element.alert.base.close'
      }
    },
    warning: {
      variant: 'spark.element.alert.base',
      backgroundColor: 'orange-25',
      borderColor: 'warning',
      title: {
        variant: 'spark.element.alert.base.title'
      },
      header: {
        variant: 'spark.element.alert.base.header'
      },
      close: {
        variant: 'spark.element.alert.base.close'
      }
    },
    success: {
      variant: 'spark.element.alert.base',
      backgroundColor: 'cyan-25',
      borderColor: 'secondary',
      title: {
        variant: 'spark.element.alert.base.title'
      },
      header: {
        variant: 'spark.element.alert.base.header'
      },
      close: {
        variant: 'spark.element.alert.base.close'
      }
    }
  }
};